import(/* webpackMode: "eager" */ "/vercel/path0/app/explore/page.tsx");
